import { render, staticRenderFns } from "./ReverseDNS.vue?vue&type=template&id=2def96dd&lang=pug&"
import script from "./ReverseDNS.vue?vue&type=script&lang=js&"
export * from "./ReverseDNS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports